var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      d: "M6.66009 20.984C6.75141 20.9947 6.84811 21 6.93944 21H17.0766C17.1733 21 17.27 20.9947 17.3667 20.984C18.6022 20.8504 19.5692 19.8779 19.6068 18.6811H4.40381C4.44142 19.8779 5.41376 20.8558 6.65472 20.984M7.9279 17.4735C8.01923 17.4788 8.11592 17.4842 8.20725 17.4842H8.24485C8.33081 17.4842 8.41139 17.4842 8.49734 17.4735C9.75978 17.3399 10.7429 16.3247 10.7429 15.0958H8.20725C7.50888 15.0958 6.93944 14.5561 6.93944 13.8989C6.93944 13.2417 7.50888 12.702 8.20725 12.702H15.8732C16.5447 12.7341 17.0766 13.2577 17.0766 13.8989C17.0766 14.5401 16.5071 15.0958 15.8088 15.0958H13.2731V15.2454C13.2731 15.2774 13.2785 15.3041 13.2839 15.3309V15.3522C13.2839 15.3843 13.2946 15.4217 13.3 15.4538V15.4644C13.4773 16.5224 14.3798 17.3506 15.5133 17.4735C15.5992 17.4788 15.6798 17.4842 15.7658 17.4842H15.8034C15.8947 17.4842 15.986 17.4842 16.0774 17.4735C18.0489 17.3399 19.6068 15.7904 19.6068 13.8935C19.6068 11.9967 17.9039 10.3029 15.8034 10.3029H8.19651C6.09602 10.3029 4.39307 11.9112 4.39307 13.8935C4.39307 15.8759 5.9456 17.3399 7.91716 17.4735M13.2785 7.90912H10.7429V9.106H13.2785V7.90912Z",
      fill: "currentColor"
    }, null, -1),
    createElementVNode("path", {
      d: "M6.02818 6.74998C6.09912 7.91784 6.99603 8.85534 8.14123 8.98391H8.15136L8.29831 8.99998H8.41486V5.39998H15.585V8.98391H15.8637C16.9937 8.85534 17.8906 7.92856 17.9768 6.78213V2.99998H6.02311V6.74998H6.02818Z",
      fill: "currentColor"
    }, null, -1)
  ]));
}
__name(render, "render");
const brandEcigames = markRaw({ name: "custom-brand-ecigames", render });
export {
  brandEcigames as default
};
//# sourceMappingURL=brand-ecigames.js.map
